export default "__VITE_ASSET__DixXLQo7__"